import ExcelJS from 'exceljs'
import { addWorksheetContent } from './createExcelHelpers'
import DateTimeFormat from './DateTimeFormat'

// Table Columns
const customerColumns = [
  {
    name: 'Etunimi',
    filterButton: true
  },
  {
    name: 'Sukunimi',
    filterButton: true
  },
  {
    name: 'Sähköposti',
    filterButton: true
  },
  {
    name: 'Rekisteröitymispäivä',
    filterButton: true
  },
  {
    name: 'Yhteensä Laskun Summa (€)',
    filterButton: true
  }
]

export default async function createExcelCustomersReport(customers) {
  // Table rows
  let customerRows = []

  for (const i of customers) {
    customerRows.push([
      i.firstname,
      i.lastname,
      i.email,
      new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(i.created)),
      i.invoicedUserInvoices
    ])
  }

  // Create Workbook and Worksheet
  const workbook = new ExcelJS.Workbook()
  workbook.creator = 'Invosy Finland'

  // Create Worksheets
  const customersWorksheet = workbook.addWorksheet('Customers')

  // Add Content to Worksheets
  addWorksheetContent(
    customersWorksheet,
    'Customers Report',
    customerColumns,
    customerRows
  )

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], { type: 'application/octet-stream' })

  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'customers.xlsx'

  link.click()

  // Clean up the temporary URL
  URL.revokeObjectURL(url)
}
